import React, { Component } from 'react';
import { Redirect } from 'react-router';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import Icon from "../components/Selfcare/Common/Icon";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import Slider from "react-slick";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Version from "version";
import ReactLoading from 'react-loading';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";

import DinSide from "assets/img/dinside.png";
import TekNo from "assets/img/tekno.png";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import ReactGA from 'react-ga';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

class ChangeSubscription extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangeSubscription", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Packages: null,
            ChangePriceplanDialogOpen: false,
            OrderSent: false,
            OrderError: '',
            OrderOpen: '',
            DisableButtons: false,
            buzy: false,
            Loading: true,
            IsAdministrating: false,
            CanChangePriceplan: true,
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            auth.signOut();
        }
        if (nextState.OrderSent && !this.state.OrderSent) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.thankyou'),
                html: nextState.EndOfMonth ? this.props.t('selfcare:notification.orderregisteredmontheffective') : this.props.t('selfcare:notification.orderregisteredminuteseffective'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.orderfailed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ buzy: false });
            });
        }
        if (nextState.OrderOpen && !this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: true });
                }.bind(this),
                100
            );
        }
        if (!nextState.OrderOpen && this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: false });
                }.bind(this),
                100
            );
        }

    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    handleConfirmChangePackageDialogClose = () => {
        this.dispatchState({
            PerformChange: { SelectedPackageNo: this.state.SelectedPackage.PackageNo }
        });
        this.setState({ ChangePriceplanDialogOpen: false, buzy: true });
    }
    handleChange = name => event => {
        this.dispatchState({ [name]: event.target.checked, ClearErrors: true });
    }

    handleChangePriceplanDialogClose = () => {
        this.setState({ ChangePriceplanDialogOpen: false, SelectedPackage: null, error: null });
    }

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    handleSelectPackage = selectedPackage => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Priceplan selected'
        });
        this.setState({ SelectedPackage: selectedPackage, ChangePriceplanDialogOpen: true });

    };

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }

    render() {
        console.debug('ChangeSubscription render');
        var settings = {
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 99999999,
                    settings: {
                        slidesToShow: 5,
                        infinite: this.state.Packages && this.state.Packages.length > 5 ? true : false,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4,
                        infinite: this.state.Packages && this.state.Packages.length > 4 ? true : false,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        infinite: this.state.Packages && this.state.Packages.length > 3 ? true : false,
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        infinite: this.state.Packages && this.state.Packages.length > 2 ? true : false,
                    } 
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        infinite: this.state.Packages && this.state.Packages.length > 1 ? true : false,
                    }
                }
                ],
        };

        const classes = this.props;
        const { t } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                <Dialog
                    open={this.state.ChangePriceplanDialogOpen}
                    onClose={this.handleChangePriceplanDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{this.state.IsSweden ? t('selfcare:title.change-subscription-type-swe') : t('selfcare:title.changesubscription')}</DialogTitle>
                    <DialogContent>
                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.wishtochangesubscription', {0: this.state.CurrentPackage ? this.state.CurrentPackage.Name : null, 1: this.state.SelectedPackage ? this.state.SelectedPackage.Name : null }) }} /> 
                        {this.state.SelectedPackage && this.state.SelectedPackage.RolloverWillBeLost ? t('selfcare:info.datarolloverwillbelost') : null}
                        {this.state.SelectedPackage && this.state.SelectedPackage.Downgrade ? t('selfcare:info.changeofsubscriptionendofmonth') : t('selfcare:info.changeofsubscriptionwhenconfirmed')}
                        {this.state.SelectedPackage && this.state.SelectedPackage.ServiceChanges &&
                            <React.Fragment>
                            <br />
                            <div style={{ color: '#FF0000' }}>{this.state.SelectedPackage.ServiceChanges}</div>
                            </React.Fragment>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmChangePackageDialogClose} color="rose">
                            {t('selfcare:button.confirmuc')}
                        </Button>
                        <Button onClick={this.handleChangePriceplanDialogClose}>
                            {t('selfcare:button.canceluc')}
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', height: '50px', paddingLeft: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.nowadministratingnumber', { 0: this.state.AdministratedMsisdn }) }} /><br /><a style={{ color: 'white' }} href='/overview' onClick={(e) => { sessionStorage.stopAdmin = this.state.LoggedInMsisdn; this.navigateTo('/overview'); e.preventDefault(); }}>{t('selfcare:button.backtologgedinuser')}</a></div>}
                {/*<Slide direction="down" in={this.state.show} mountOnEnter unmountOnExit>*/}
                        <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                            <GridContainer justify="center">
                                <GridItem xs={10} >
                                    <Icon name="money" size={48} color="#FFFFFF" />
                                    <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {this.state.IsSweden ? t('selfcare:title.change-subscription-type-swe') : t('selfcare:title.changesubscription')}
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </div>
                {/*</Slide>
                <Slide direction="up" in={this.state.show} mountOnEnter unmountOnExit>*/}
                            <form>
                        {!this.state.CanChangePriceplan && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}>{t('selfcare:info.howtochangesubscriptiontype')}</div>}
                        <GridContainer justify="center" alignItems="center">
                            <GridItem xs={10}>
                                     <Slider {...settings}>
                                                {this.state.Packages ? this.state.Packages.map((pack) => {
                                        return (
                                            <Card pricing raised key={pack.PackageNo} style={{ width: '150px' }}>
                                                <CardBody pricing>
                                                    <div style={{ textAlign: 'left' }}>
                                                        <h5 style={{ color: '#eb4e69', margin: '0px' }}>Chili</h5>
                                                        <h3 style={{ marginTop: '10px', marginBottom: '10px' }} className={classes.cardCategory}>{pack.Name}</h3>
                                                    </div>
                                                    <div className={classes.icon}>
                                                        {pack.Picture === 'TEK.NO' ? <img src={TekNo} alt="TEK.No" style={{ width: '90px', position: 'absolute', right: '-23px', top: '-23px' }} /> : null}
                                                        {pack.Picture === 'DinSide' ? <img src={DinSide} alt="DinSide" style={{ width: '90px', position: 'absolute', right: '-23px', top: '-23px' }} /> : null}
                                                    </div>
                                                    <div style={{ height: '120px' }} className={classes.cardDescription} dangerouslySetInnerHTML={{ __html: pack.DescriptionHTML }} />
                                                    <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                                                        {pack.MonthlyPrice}
                                                    </h3>
                                                    {pack.Ordered ? <Button round disabled>Bestilt</Button> : !pack.CurrentPackage ? <Button round color="rose" disabled={this.state.DisableButtons || this.state.buzy || !this.state.CanChangePriceplan} onClick={() => this.handleSelectPackage(pack)}>{t('selfcare:button.changeto')}</Button> : <Button round disabled>{t('selfcare:button.current')}</Button>}
                                                </CardBody>
                                            </Card>
                                        )
                                                }) : null }
                                </Slider>
                            </GridItem>
                            </GridContainer>
                            <GridContainer direction="column" justify="center" alignItems="center">
                            <GridItem>
                                {this.state.Loading && <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />}
                            </GridItem>
                            <GridItem>
                                <div style={{ paddingTop: '40px' }}>
                                    {this.state.buzy && <CircularProgress size={48} style={{
                                        color: '#C2185B', position: 'absolute',
                                        top: '20%',
                                        left: '50%',
                                        marginTop: -12,
                                        marginLeft: -12,
                                    }} />}
                                    {this.state.OrderOpen && <div>{t('selfcare:info.orderprocessed')}</div>}
                                    <Button id='back' color="rose" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button>
                                </div>
                            </GridItem>
                          </GridContainer>
                    </form>
                {/*</Slide>*/}
            </div>
        );
    }
}
ChangeSubscription.propTypes = {
};

export default compose(
    withStyles(pricingPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, ChangeSubscription));